/* global axios */
import ApiClient from '../ApiClient';

class AnalysisRuns extends ApiClient {
  constructor() {
    super('analysis/runs', { accountScoped: true });
  }

  get({ page = 1, analyzerId } = {}) {
    return axios.get(this.url, { params: { page, analyzer_id: analyzerId } });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // What the run would cost, asked before anything is spent.
  preview(params = {}) {
    return axios.get(`${this.url}/preview`, { params });
  }

  create(data = {}) {
    return axios.post(this.url, { run: data });
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new AnalysisRuns();
